import { API_TYPE } from '@umu/umu-fetch';
const BasePath = '/uapi/v1/profile';

export const ProfileAPI = {
    /**
     * 目标用户信息
     */
    PROFILE_TARGET_USER_INFO: {
        url: `${BasePath}/base-info`,
        type: API_TYPE.GET,
    },
    PROFILE_MESSAGES: {
        url: `${BasePath}/message-list`,
        type: API_TYPE.GET,
    },
    PROFILE_SAVE_MESSAGE: {
        url: `${BasePath}/message-save`,
        type: API_TYPE.POST,
    },
    PROFILE_MESSAGE_ELITE: {
        url: `${BasePath}/message-elite`,
        type: API_TYPE.POST,
    },
    PROFILE_MESSAGE_LIKE: {
        url: `${BasePath}/message-like`,
        type: API_TYPE.POST,
    },
    PROFILE_MESSAGE_DEL: {
        url: `${BasePath}/message-delete`,
        type: API_TYPE.POST,
    },
    PROFILE_MESSAGE_UNREAD: {
        url: `${BasePath}/message-unread-count`,
        type: API_TYPE.GET,
    },
    PROFILE_FOLLOW_LIST: {
        url: '/api/focus/attentionlist',
        type: API_TYPE.GET,
    },
    PROFILE_FANS_LIST: {
        url: '/api/focus/followlist',
        type: API_TYPE.GET,
    },

    /**
     * 管理学习圈列表
     */
    MANAGE_CIRCLE_LIST: {
        url: `${BasePath}/circle-admin-list`,
        type: API_TYPE.GET,
    },

    /**
     * 加入学习圈列表
     */
    JOIN_CIRCLE_LIST: {
        url: `${BasePath}/circle-join-list`,
        type: API_TYPE.GET,
    },

    /**
     * 管理课程列表
     */
    MANAGE_COURSE_LIST: {
        url: `${BasePath}/course-admin-list`,
        type: API_TYPE.GET,
    },

    /**
     * 加入课程列表
     */
    JOIN_COURSE_LIST: {
        url: `${BasePath}/course-participate-list`,
        type: API_TYPE.GET,
    },

    /**
     * 设置学习圈和课程 隐藏和显示
     */
    CIRCLE_SET_OBJ_HIDDEN: {
        url: `${BasePath}/set-obj-hidden`,
        type: API_TYPE.POST,
    },
};
